<div class="choose-loc-dialog">
    <div class="title_div">
        <h4 mat-dialog-title class="location_dialog_h4 global-h4">Select Location</h4>
    </div>

    <div class="choose-loc-body-div">
        <mat-card appearance="outlined" class="mainCard">
            <mat-dialog-content>

                <form class="global-form" [formGroup]="form" (ngSubmit)="onProceedClick()" style="height: 100%;">
                    <div class="choose-loc-div">
                        <div class="childDiv-choose-location">
                            <!-- <div class="iconDiv">
                            <i mat-card-image class="material-icons">
                                business
                            </i>
                        </div> -->
                            <mat-card appearance="outlined" class="childCard">
                                <mat-form-field appearance="fill" class="selectOption">

                                    <mat-label>Select Company</mat-label>
                                    <mat-select panelClass="custom-select-panel" formControlName="companyRefNo"
                                        (selectionChange)="onCompanySelect($event.value)" required>
                                        <mat-option *ngFor="let company of companyList" [value]="company.refNo">
                                            {{company.companyName}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="childDiv-choose-location">
                            <!-- <div class="iconDiv">
                            <i class="material-icons">
                                room
                            </i>
                        </div> -->
                            <mat-card appearance="outlined" class="childCard">
                                <mat-form-field appearance="fill" class="selectOption">

                                    <mat-label>Select Parent Location</mat-label>
                                    <mat-select panelClass="custom-select-panel" formControlName="parentLocRefNo"
                                        (selectionChange)="onParentLocationSelect($event.value)" required>
                                        <mat-option *ngFor="let loc of parentLocList" [value]="loc.refNo">
                                            {{loc.locationName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>
                        </div>
                        <div class="childDiv-choose-location">
                            <!-- <div class="iconDiv">
                            <i class="material-icons">
                                room
                            </i>
                        </div> -->
                            <mat-card appearance="outlined" class="childCard">
                                <mat-form-field appearance="fill" class="selectOption">

                                    <mat-label>Select Location</mat-label>
                                    <mat-select panelClass="custom-select-panel" formControlName="locationRefNo"
                                        (selectionChange)="onLocationSelect($event.value)" required>
                                        <mat-option *ngFor="let loc of locList" [value]="loc.refNo">{{loc.locationName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </mat-card>
                        </div>
                    </div>

                    <div class="choose-loc-proceed-div">
                        <!-- <button mat-raised-button color="primary" type="button" class="doneBtn global-button">
                        <mat-icon>arrow_back</mat-icon>
                        <span>BACK</span>
                        </button> -->
                        <button class="global-button" type="button" mat-raised-button id="choose-loc-backbtn" (click)="onBackClick()">
                            <span>BACK</span>
                            <!-- <mat-icon class="choose-loc-back-icon icon-style"
                                style="height: 0px !important;line-height: 0px !important;overflow: visible;top: 0px !important;">arrow_backword
                            </mat-icon> -->
                        </button>
                        <button class="global-button" type="submit" mat-raised-button id="choose-loc-proceedbtn">
                            <span>PROCEED</span>
                            <!-- <mat-icon class="choose-loc-proceed-icon icon-style"
                                style="height: 0px !important;line-height: 0px !important;overflow: visible;top: 0px !important;">arrow_forward
                            </mat-icon> -->
                        </button>
                        <!-- <button mat-raised-button color="primary" type="submit" class="doneBtn global-button">
                        <span>PROCEED</span>
                        <mat-icon>done</mat-icon>
                        </button> -->
                    </div>
                    <!-- <mat-form-field appearance="fill"  [hidden]="true">
                        <input class="global-input" matInput type="text">
                    </mat-form-field>
                    <mat-form-field appearance="fill"  [hidden]="true">
                        <input class="global-input" matInput type="text">
                    </mat-form-field> -->
                </form>
            </mat-dialog-content>
        </mat-card>
    </div>
    <!-- <div class="choose-loc-footer-div">
     <h2>Live Voice-to-Products</h2>
    <button (click)="start()">🎤 Start Listening</button>
    <button (click)="stop()">🛑 Stop Listening</button>
    <button (click)="callCustomer()">Call Customer</button>
    <ul>
      <li *ngFor="let p of products">{{ p.qty }} x {{ p.product }}</li>
    </ul>
    </div> -->
</div>